import { useEffect, useRef, useState } from 'react';
import { btn, c, z } from '../../theme';

// One choice from a list, or none — the old dashboard's "All languages ▾".
// The same chrome as MultiSelect so a filter row reads as one row, but a
// radio choice rather than a set: an agent is filtered by one language at a
// time there, and two at once has no meaning.
//
// `align` and the stacking order carry the same reasoning as MultiSelect's —
// read the note there. This control had the identical defect and would have
// been left behind by a fix applied only to the other one, which is the usual
// way two components that "look the same" stop behaving the same.

export default function SingleSelect({ label, options, value, onChange, allLabel = 'All', align = 'right' }) {
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (box.current && !box.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);

  const pick = (v) => { onChange(v); setOpen(false); };

  return (
    <div ref={box} style={s.wrap}>
      <button type="button" onClick={() => setOpen((v) => !v)} style={s.button}
        aria-expanded={open} aria-haspopup="true">
        <span style={s.label}>{label}:</span>
        <span style={s.value}>{value || allLabel}</span>
        <span style={s.caret}>▾</span>
      </button>
      {open && (
        <div style={{ ...s.menu, ...(align === 'left' ? s.menuLeft : s.menuRight) }}
          role="group" aria-label={label}>
          <button type="button" onClick={() => pick('')} style={value ? s.row : s.rowOn}>{allLabel}</button>
          {options.map((o) => (
            <button key={o} type="button" onClick={() => pick(o)} style={value === o ? s.rowOn : s.row}>{o}</button>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  wrap:   { position: 'relative' },
  button: { ...btn.secondaryXs, display: 'inline-flex', alignItems: 'center', gap: '6px' },
  label:  { color: c.textMuted },
  value:  { color: c.textStrong, fontWeight: 600 },
  caret:  { fontSize: '9px', opacity: 0.6 },
  menu:   { position: 'absolute', marginTop: '4px', width: '190px', zIndex: z.menu, padding: '4px 0',
    background: c.surface, border: `1px solid ${c.border}`, borderRadius: '8px', boxShadow: '0 8px 24px rgba(15,23,42,0.12)' },
  menuLeft:  { left: 0 },
  menuRight: { right: 0 },
  row:    { all: 'unset', display: 'block', width: '100%', boxSizing: 'border-box', cursor: 'pointer',
    padding: '5px 12px', fontSize: '12px', color: c.textStrong },
  rowOn:  { all: 'unset', display: 'block', width: '100%', boxSizing: 'border-box', cursor: 'pointer',
    padding: '5px 12px', fontSize: '12px', color: c.textStrong, fontWeight: 700, background: c.surfaceSunk },
};
